import { api_url } from "@/constants/base_url";

export default function getImageUrl(image) {
  if (!image) return "";
  if (typeof image !== "string") return image[0]?.path || "";
  if (image.startsWith("http")) return image;
  return `${api_url.slice(0, -8)}${image}`;
}
